import { busRouteByIdsDomainSelector, makeNullSafeDomainGetter, createIsLoadingSelector, createNullSafeDomainMetaVariablesSelector } from './common';

export const busRouteByIdsSelector = makeNullSafeDomainGetter(busRouteByIdsDomainSelector, 'busRouteByIds');
export const isBusRouteByIdsLoadingSelector = createIsLoadingSelector(busRouteByIdsDomainSelector);
export const isBusRouteByIdsVariableSelector = createNullSafeDomainMetaVariablesSelector(busRouteByIdsDomainSelector);
